module.exports = __webpack_public_path__ + "static/img/LOGO.2db2e94.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/LOGO.png
// module id = H4HJ
// module chunks = 3